import configuration from "@intlayer/config/built";
import { fetcher } from "../fetcher.mjs";
const getAiAPI = (authAPIOptions = {}, intlayerConfig) => {
  const backendURL = intlayerConfig?.editor?.backendURL ?? configuration.editor?.backendURL;
  if (!backendURL) {
    throw new Error(
      "Backend URL is not defined in the Intlayer configuration."
    );
  }
  const AI_API_ROUTE = `${backendURL}/api/ai`;
  const customQuery = async (body, otherOptions = {}) => await fetcher(
    AI_API_ROUTE,
    authAPIOptions,
    otherOptions,
    {
      method: "POST",
      body
    }
  );
  const translateJSON = async (body, otherOptions = {}) => await fetcher(
    `${AI_API_ROUTE}/translate/json`,
    authAPIOptions,
    otherOptions,
    {
      method: "POST",
      body
    }
  );
  const auditContentDeclaration = async (body, otherOptions = {}) => await fetcher(
    `${AI_API_ROUTE}/audit/dictionary`,
    authAPIOptions,
    otherOptions,
    {
      method: "POST",
      body
    }
  );
  const auditContentDeclarationField = async (body, otherOptions = {}) => await fetcher(
    `${AI_API_ROUTE}/audit/dictionary/field`,
    authAPIOptions,
    otherOptions,
    {
      method: "POST",
      body
    }
  );
  const auditContentDeclarationMetadata = async (body, otherOptions = {}) => await fetcher(
    `${AI_API_ROUTE}/audit/dictionary/metadata`,
    authAPIOptions,
    otherOptions,
    {
      method: "POST",
      body
    }
  );
  const auditTag = async (body, otherOptions = {}) => await fetcher(
    `${AI_API_ROUTE}/audit/tag`,
    authAPIOptions,
    otherOptions,
    {
      method: "POST",
      body
    }
  );
  const askDocQuestion = async (body, otherOptions = {}) => {
    if (!body) return;
    const { onMessage, onDone, ...rest } = body;
    const abortController = new AbortController();
    try {
      const response = await fetch(`${AI_API_ROUTE}/ask`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...authAPIOptions.headers,
          ...otherOptions.headers
        },
        body: JSON.stringify({
          ...rest,
          ...authAPIOptions.body,
          ...otherOptions.body
        }),
        signal: abortController.signal,
        credentials: "include"
      });
      if (!response.ok) {
        let errorMessage = "An error occurred";
        try {
          const errorData = await response.json();
          errorMessage = JSON.stringify(errorData.error) ?? "An error occurred";
        } catch {
          try {
            const errorText = await response.text();
            if (errorText) {
              errorMessage = errorText;
            }
          } catch {
          }
        }
        throw new Error(errorMessage);
      }
      const reader = response.body?.getReader();
      if (!reader) {
        throw new Error("No reader available");
      }
      const decoder = new TextDecoder();
      let buffer = "";
      while (true) {
        const { done, value } = await reader.read();
        if (done) break;
        buffer += decoder.decode(value, { stream: true });
        const lines = buffer.split("\n");
        buffer = lines.pop() ?? "";
        for (const line of lines) {
          if (line.startsWith("data: ")) {
            try {
              const data = JSON.parse(line.slice(6));
              if (data.chunk) {
                onMessage?.(data.chunk);
              }
              if (data.done && data.response) {
                onDone?.(data.response);
              }
            } catch (e) {
              console.error("Failed to parse SSE data:", e);
            }
          }
        }
      }
    } catch (error) {
      console.error("Error in askDocQuestion:", error);
      throw error;
    }
  };
  const autocomplete = async (body, otherOptions = {}) => await fetcher(
    `${AI_API_ROUTE}/autocomplete`,
    authAPIOptions,
    otherOptions,
    {
      method: "POST",
      body
    }
  );
  return {
    customQuery,
    translateJSON,
    auditContentDeclaration,
    auditContentDeclarationField,
    auditContentDeclarationMetadata,
    auditTag,
    askDocQuestion,
    autocomplete
  };
};
export {
  getAiAPI
};
//# sourceMappingURL=ai.mjs.map